/* Native Collection-Facetten: Vorschau erhalten, Lagerfilter bleibt fest. */
(() => {
  if (window.__jcNativeFacets) return;
  window.__jcNativeFacets = true;

  document.addEventListener('facet:update', (event) => {
    if (!event.target.closest('[data-jc-native-collection]')) return;
    const url = event.detail.url;
    const current = new URL(window.location.href);
    // Sprachpfad und Vorschau gehören zur aktuellen Collection.
    url.pathname = current.pathname;
    if (current.searchParams.has('view')) {
      url.searchParams.set('view', current.searchParams.get('view'));
    }
    // Bei anderer Warengruppe keine alte EU-Größe in die neue Familie übernehmen.
    const marketSizes = event.target.closest('[data-jc-native-collection]').querySelector('facets-form[data-jc-size-market="true"]');
    if (marketSizes && JSON.stringify(current.searchParams.getAll('filter.p.product_type').sort()) !== JSON.stringify(url.searchParams.getAll('filter.p.product_type').sort())) {
      for (const key of [...url.searchParams.keys()]) {
        if (/^filter\.v\.option\.(größe|grösse|groesse|size|taille|taglia|maat|storlek|rozmiar)$/i.test(key)) url.searchParams.delete(key);
      }
    }
    url.searchParams.delete('filter.p.tag');
    // Seiten mit Lager-Default behalten ihn bei jedem Filterwechsel; ohne Default bleibt leer = alle.
    const lagerFest = !!event.target.closest('[data-jc-native-collection]').querySelector('input[type="hidden"][name="filter.v.availability"][value="1"]');
    if (lagerFest && !url.searchParams.has('filter.v.availability')) {
      url.searchParams.set('filter.v.availability', '1');
    }
  }, true);
})();
